import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from "environments/environment";
import { lastValueFrom } from 'rxjs';
import { EcliSettings } from '../models/settings.model';
import { GS1NotificationService } from '@gs1france/gs1-components-library';
import { TranslateService } from '@ngx-translate/core';
let __URL_API__  = `${environment.URL_API}`;


@Injectable({providedIn: 'root'})
export class SettingService {

    constructor(private _http: HttpClient, private notificationService: GS1NotificationService, private translate: TranslateService) { }
    
    async getSettings(): Promise<EcliSettings> {
        try {
            const settings: EcliSettings = await lastValueFrom(this._http.get<EcliSettings>(`${__URL_API__}api/EcliSettings`));
            return settings;
        } catch (err) {
            return await this.handleError(err, 'GlobalErrors.default');
        }
    }
    
    private handleError(error: any, message?: string): Promise<any> {
        if (message) {
            this.notificationService.addNotification(this.translate.instant(message), 'error');
        }
        return Promise.reject(error.message || error);
    }
    
}